import teeVent1 from "@/assets/tee-vent-1.webp";
import teeVent2 from "@/assets/tee-vent-2.webp";
import teeVent3 from "@/assets/tee-vent-3.webp";
import teeRoots from "@/assets/tee-roots.jpg";
// 600px versions. Cards paint at ~276px CSS; shipping the 1000px+ originals
// meant decoding 4.8 MP to paint 1.7 MP worth of pixels, and re-rasterising
// all of it on every hover.
import teeVent1Card from "@/assets/tee-vent-1-card.webp";
import teeVent2Card from "@/assets/tee-vent-2-card.webp";
import teeVent3Card from "@/assets/tee-vent-3-card.webp";
import teeRootsCard from "@/assets/tee-roots-card.webp";

export interface Product {
  id: string;
  name: string;
  eyebrow: string;
  blurb: string;
  price: string;
  image: string;
  cardImage: string;
  alt: string;
}

/**
 * PLACEHOLDER COPY — swap for real product content.
 * Names, blurbs and prices are stand-ins; the images are the genuine
 * Path & Pace mockups. Replacing this array is the only edit needed.
 */
export const PRODUCTS: Product[] = [
  {
    id: "vent-core",
    name: "Metal Vent Tech Tee",
    eyebrow: "Everyday run",
    blurb: "Open-weave body that moves air instead of holding heat.",
    price: "$48",
    image: teeVent1,
    cardImage: teeVent1Card,
    alt: "Path and Pace Metal Vent Tech short-sleeve tee, front view",
  },
  {
    id: "vent-light",
    name: "Metal Vent Tech — Light",
    eyebrow: "Warm weather",
    blurb: "The same weave, taken down a weight for summer mileage.",
    price: "$48",
    image: teeVent2,
    cardImage: teeVent2Card,
    alt: "Path and Pace Metal Vent Tech tee in a lighter colourway",
  },
  {
    id: "vent-dark",
    name: "Metal Vent Tech — Dark",
    eyebrow: "All conditions",
    blurb: "Low-glare finish for early starts and late finishes.",
    price: "$48",
    image: teeVent3,
    cardImage: teeVent3Card,
    alt: "Path and Pace Metal Vent Tech tee in a dark colourway",
  },
  {
    id: "roots",
    name: "Roots Tee",
    eyebrow: "Off the clock",
    blurb: "Heavier cotton hand. Built for the walk back, not the split.",
    price: "$42",
    image: teeRoots,
    cardImage: teeRootsCard,
    alt: "Path and Pace Roots tee in pale blue, front view",
  },
];
